import { matchesTokens } from '@/components/timesheet/week-rows'

/** Alleen de namen waaronder een kans te vinden is. */
interface Searchable {
  name: string
  client: { name: string } | null
  project: { name: string } | null
}

/**
 * Een kans is bekend onder drie namen: die van de klus zelf, die van de klant en
 * die van het project. Ze gaan als een tekst door de tokenizer, dus "buva support"
 * vindt ook de klus die zijn klantnaam en zijn projectnaam over twee velden
 * verdeelt.
 */
export function matchesOpportunity(opportunity: Searchable, search: string): boolean {
  return matchesTokens(
    [opportunity.name, opportunity.client?.name ?? '', opportunity.project?.name ?? ''].join(' '),
    search,
  )
}

/** Zonder zoekterm dezelfde lijst terug, zodat er niets onnodig opnieuw rendert. */
export function filterOpportunities<T extends Searchable>(opportunities: T[], search: string): T[] {
  if (search.trim() === '') return opportunities

  return opportunities.filter((opportunity) => matchesOpportunity(opportunity, search))
}
